import { AuthContext, CoderRulesDashboard, isTabletPortraitDown } from '@enter/core';
import { mdiArrowLeft } from '@mdi/js';
import { Icon } from '@mdi/react';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { RootStore } from 'stores';
import * as S from './shared.styles';

export const CodingRules: React.FunctionComponent<{}> = inject('rootStore')(
    observer((props: {}): React.ReactElement => {
        const rootStore: RootStore = _.get(props, 'rootStore');
        const authContext = useContext(AuthContext);
        const { accountId } = useParams<{ accountId?: string }>();

        if (!rootStore) {
            return <></>;
        }

        return (
            <S.SubCategoryCol>
                <S.SubCategoryItem key="coding-rules">
                    <S.SubCategoryItemRow>
                        <S.SubCategoryH1>
                            {isTabletPortraitDown() && (
                                <S.ReturnLink to={accountId ? `/${accountId}/claims` : '/claims'}>
                                    {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                                </S.ReturnLink>
                            )}
                            Coders
                        </S.SubCategoryH1>
                    </S.SubCategoryItemRow>
                    <CoderRulesDashboard
                        autoLoad={true}
                        endpoint="provider"
                        getAccessToken={authContext.getCurrentAccessToken}
                        showConnectionControls={false}
                        userId={rootStore.userId}
                        userName={rootStore.userName || 'Current user'}
                    />
                </S.SubCategoryItem>
            </S.SubCategoryCol>
        );
    }),
);
